var _g, _rect, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSponsoredDisplaySoon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7450_49056)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 84,
    height: 25,
    rx: 5,
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0584 15.0332C44.9779 15.0503 44.8407 15.0981 44.7536 15.1393C44.5363 15.2424 44.2469 15.5254 44.1419 15.7376C43.9881 16.0482 43.9961 15.7708 44.003 20.5797L44.0092 24.9446L44.0724 25.1139C44.2216 25.5137 44.5368 25.8159 44.9394 25.9449L45.1112 26H50H54.8888L55.0606 25.9449C55.4632 25.8159 55.7784 25.5137 55.9276 25.1139L55.9908 24.9446L55.997 20.5797C56.0039 15.7708 56.0119 16.0482 55.8581 15.7376C55.7533 15.5258 55.4636 15.2423 55.2472 15.1398C54.9328 14.9907 55.2464 14.999 49.9883 15.0006C46.0512 15.0018 45.1791 15.0075 45.0584 15.0332ZM52.1589 17.0388C52.4345 17.1226 52.6903 17.3174 52.862 17.5745C53.2817 18.2028 53.0358 19.0667 52.342 19.4014C51.4995 19.8079 50.5301 19.2617 50.4543 18.3378C50.4047 17.7339 50.8602 17.1437 51.483 17.0048C51.6707 16.963 51.9568 16.9773 52.1589 17.0388ZM48.3537 19.6309C48.4016 19.655 48.4721 19.707 48.5104 19.7464C48.5486 19.7859 49.0973 20.48 49.7296 21.2889C50.7861 22.6405 50.8895 22.7653 51.005 22.8291C51.1555 22.9121 51.3444 22.9219 51.4919 22.8543C51.5418 22.8315 51.7576 22.6455 51.9713 22.4411C52.3818 22.0486 52.4276 22.0196 52.6391 22.0194C52.7785 22.0192 52.9519 22.1128 53.052 22.2424C53.245 22.4924 54.4894 24.2412 54.5404 24.3342C54.635 24.5069 54.5981 24.6647 54.4466 24.735C54.3728 24.7693 53.9989 24.7725 50.0899 24.7725C45.9732 24.7725 45.8108 24.7709 45.7322 24.73C45.6235 24.6735 45.5448 24.5571 45.5455 24.4536C45.5458 24.4082 45.5701 24.3142 45.5995 24.2448C45.7164 23.969 47.8971 19.7779 47.9559 19.7163C48.0783 19.5879 48.2114 19.5593 48.3537 19.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 39,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6259 45.2191C14.5635 45.2323 14.4573 45.2693 14.3899 45.3012C14.2217 45.381 13.9976 45.6001 13.9163 45.7644C13.7973 46.0049 13.8034 45.7901 13.8087 49.5131L13.8136 52.8924L13.8625 53.0235C13.978 53.333 14.2221 53.5669 14.5337 53.6669L14.6667 53.7095H18.4516H22.2365L22.3695 53.6669C22.6812 53.5669 22.9252 53.333 23.0408 53.0235L23.0897 52.8924L23.0945 49.5131C23.0998 45.7901 23.106 46.0049 22.9869 45.7644C22.9058 45.6004 22.6815 45.381 22.514 45.3016C22.2706 45.1862 22.5134 45.1926 18.4425 45.1938C15.3945 45.1947 14.7193 45.1992 14.6259 45.2191ZM20.123 46.7718C20.3364 46.8366 20.5345 46.9875 20.6673 47.1865C20.9923 47.673 20.8019 48.3418 20.2648 48.6009C19.6125 48.9156 18.862 48.4928 18.8033 47.7775C18.7649 47.3099 19.1176 46.853 19.5998 46.7455C19.7451 46.7131 19.9665 46.7242 20.123 46.7718ZM17.1771 48.7786C17.2141 48.7973 17.2687 48.8375 17.2984 48.868C17.328 48.8986 17.7528 49.4359 18.2423 50.0622C19.0602 51.1086 19.1403 51.2052 19.2297 51.2546C19.3462 51.3189 19.4924 51.3264 19.6066 51.2741C19.6453 51.2564 19.8123 51.1125 19.9778 50.9542C20.2956 50.6503 20.3311 50.6279 20.4948 50.6277C20.6027 50.6276 20.737 50.7001 20.8145 50.8004C20.9639 50.9939 21.9273 52.3479 21.9668 52.4199C22.04 52.5535 22.0115 52.6757 21.8942 52.7301C21.837 52.7567 21.5476 52.7592 18.5212 52.7592C15.3341 52.7592 15.2084 52.7579 15.1475 52.7263C15.0633 52.6825 15.0025 52.5924 15.003 52.5123C15.0032 52.4771 15.022 52.4044 15.0448 52.3506C15.1353 52.1371 16.8236 48.8924 16.8691 48.8447C16.9639 48.7453 17.0669 48.7232 17.1771 48.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 62.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 66.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 39,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1743 45.2191C46.1119 45.2323 46.0057 45.2693 45.9383 45.3012C45.7701 45.381 45.546 45.6001 45.4647 45.7644C45.3457 46.0049 45.3518 45.7901 45.3571 49.5131L45.362 52.8924L45.4109 53.0235C45.5264 53.333 45.7705 53.5669 46.0821 53.6669L46.2151 53.7095H50H53.7849L53.9179 53.6669C54.2296 53.5669 54.4736 53.333 54.5892 53.0235L54.6381 52.8924L54.6429 49.5131C54.6482 45.7901 54.6544 46.0049 54.5353 45.7644C54.4542 45.6004 54.2299 45.381 54.0624 45.3016C53.819 45.1862 54.0618 45.1926 49.9909 45.1938C46.9429 45.1947 46.2677 45.1992 46.1743 45.2191ZM51.6714 46.7718C51.8848 46.8366 52.0829 46.9875 52.2157 47.1865C52.5407 47.673 52.3503 48.3418 51.8132 48.6009C51.1609 48.9156 50.4104 48.4928 50.3517 47.7775C50.3133 47.3099 50.666 46.853 51.1482 46.7455C51.2935 46.7131 51.5149 46.7242 51.6714 46.7718ZM48.7255 48.7786C48.7625 48.7973 48.8171 48.8375 48.8468 48.868C48.8764 48.8986 49.3012 49.4359 49.7907 50.0622C50.6086 51.1086 50.6887 51.2052 50.7781 51.2546C50.8946 51.3189 51.0408 51.3264 51.155 51.2741C51.1937 51.2564 51.3607 51.1125 51.5262 50.9542C51.844 50.6503 51.8795 50.6279 52.0432 50.6277C52.1511 50.6276 52.2854 50.7001 52.3629 50.8004C52.5123 50.9939 53.4757 52.3479 53.5152 52.4199C53.5884 52.5535 53.5599 52.6757 53.4426 52.7301C53.3854 52.7567 53.096 52.7592 50.0696 52.7592C46.8825 52.7592 46.7568 52.7579 46.6959 52.7263C46.6117 52.6825 46.5509 52.5924 46.5514 52.5123C46.5516 52.4771 46.5704 52.4044 46.5932 52.3506C46.6837 52.1371 48.372 48.8924 48.4175 48.8447C48.5123 48.7453 48.6153 48.7232 48.7255 48.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 62.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 66.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 39,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7227 45.2191C77.6603 45.2323 77.5541 45.2693 77.4867 45.3012C77.3184 45.381 77.0944 45.6001 77.0131 45.7644C76.894 46.0049 76.9002 45.7901 76.9055 49.5131L76.9103 52.8924L76.9592 53.0235C77.0748 53.333 77.3188 53.5669 77.6305 53.6669L77.7635 53.7095H81.5484H85.3333L85.4663 53.6669C85.778 53.5669 86.022 53.333 86.1375 53.0235L86.1865 52.8924L86.1913 49.5131C86.1966 45.7901 86.2027 46.0049 86.0837 45.7644C86.0025 45.6004 85.7783 45.381 85.6108 45.3016C85.3673 45.1862 85.6102 45.1926 81.5393 45.1938C78.4912 45.1947 77.816 45.1992 77.7227 45.2191ZM83.2198 46.7718C83.4332 46.8366 83.6312 46.9875 83.7641 47.1865C84.089 47.673 83.8987 48.3418 83.3616 48.6009C82.7093 48.9156 81.9588 48.4928 81.9001 47.7775C81.8617 47.3099 82.2143 46.853 82.6966 46.7455C82.8419 46.7131 83.0633 46.7242 83.2198 46.7718ZM80.2739 48.7786C80.3109 48.7973 80.3655 48.8375 80.3951 48.868C80.4248 48.8986 80.8495 49.4359 81.3391 50.0622C82.157 51.1086 82.237 51.2052 82.3265 51.2546C82.443 51.3189 82.5892 51.3264 82.7034 51.2741C82.7421 51.2564 82.9091 51.1125 83.0746 50.9542C83.3924 50.6503 83.4279 50.6279 83.5916 50.6277C83.6995 50.6276 83.8337 50.7001 83.9112 50.8004C84.0607 50.9939 85.0241 52.3479 85.0635 52.4199C85.1368 52.5535 85.1082 52.6757 84.991 52.7301C84.9338 52.7567 84.6444 52.7592 81.618 52.7592C78.4309 52.7592 78.3052 52.7579 78.2443 52.7263C78.1601 52.6825 78.0992 52.5924 78.0998 52.5123C78.1 52.4771 78.1188 52.4044 78.1416 52.3506C78.2321 52.1371 79.9204 48.8924 79.9658 48.8447C80.0607 48.7453 80.1637 48.7232 80.2739 48.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 62.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 66.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 69,
    rx: 5.5,
    stroke: "var(--secondary-1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7450_49056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoredDisplaySoon);
export default __webpack_public_path__ + "static/media/sponsored-display-soon.abb838497a3d81d447cb1b6b215d51c1.svg";
export { ForwardRef as ReactComponent };